
/**
 * Проверка доступности Comagic
 */
export function isComagicAvailable() {
  return typeof window.Comagic !== 'undefined' && 
         typeof window.Comagic.addOfflineRequest === 'function';
}

/**
 * Валидация телефона
 */
export function validatePhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 11 && (cleaned[0] === '7' || cleaned[0] === '8');
}

/**
 * Отправка в Comagic
 */
export async function sendToComagic(formData, formElement) {
  if (!isComagicAvailable()) {
    console.log('Comagic не доступен, пропускаем отправку');
    return true;
  }

  const comagicData = {
    phone: formData.get('phone'),
    name: formData.get('name') || '',
    form_name: formElement.getAttribute('data-type') || 'Форма с сайта',
    message: Array.from(formData.entries())
      .filter(([key]) => !['phone', 'name', '_token'].includes(key))
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n')
  };

  return new Promise((resolve) => {
    window.Comagic.addOfflineRequest(comagicData, function(o) {
      if (o instanceof XMLHttpRequest) {
        o = JSON.parse(o.response);
      }
      resolve(o.success);
    });
  });
}

/**
 * Показ сообщения
 */
export function showMessage(message, type = 'success') {
  const messageContainer = document.createElement('div');
  const messageTitle = document.createElement('div');
  const messageBg = document.createElement('div');
  
  messageContainer.className = `show__message show__message--${type}`;
  messageTitle.className = 'show__message-title';
  messageBg.className = 'show__message-bg';
  messageTitle.textContent = message;
  
  messageContainer.appendChild(messageTitle);
  document.body.appendChild(messageContainer);
  document.body.appendChild(messageBg);
  
  messageBg.addEventListener('click', () => {
    messageContainer.remove();
    messageBg.remove();
  });
}

/**
 * Обработчик отправки формы
 */
export async function handleFormSubmit(e) {
  e.preventDefault();
  
  const form = e.target;
  const phoneInput = form.querySelector('input[name="phone"]');
  const submitButton = form.querySelector('button');
  const checkbox = form.querySelector('input[name="politic"]');
  const checkMark = form.querySelector('.checkmark-check');
  const phone = phoneInput.value;

  phoneInput.style.border = '1px solid #e8e8e8';

  if (!validatePhone(phone)) {
    if (phoneInput.errorTimeout) clearTimeout(phoneInput.errorTimeout);
    phoneInput.errorTimeout = setTimeout(() => {
      phoneInput.style.border = '1px solid red';
    }, 300);
    return false;
  }

  if (!checkbox.checked) {
    checkMark.classList.add('highlight-animation');
    checkMark.style.border = '1px solid red';
    setTimeout(() => {
      checkMark.classList.remove('highlight-animation');
    }, 1000);
    return false;
  }

  submitButton.disabled = true;
  submitButton.innerHTML = 'Отправка';

  const type = form.getAttribute('data-type') || '';
  const formData = new FormData(form);
  formData.append('type', type);

  try {
    const promises = [
      fetch("/sendform", {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content,
        }
      })
    ];

    if (isComagicAvailable()) {
      promises.push(sendToComagic(formData, form));
    }

    const [serverResponse, comagicResponse] = await Promise.all(promises);
    
    if (!serverResponse.ok) throw new Error("Ошибка сервера");
    
    form.reset();
    
    const successMessage = comagicResponse === false 
      ? 'Заявка принята, но возникла проблема с системой уведомлений. Мы вам перезвоним.'
      : 'Спасибо! Заявка отправлена. В ближайшее время с Вами свяжется менеджер.';
    
    showMessage(successMessage);
    
    if (typeof ym !== 'undefined') {
      ym(108317488, 'reachGoal', 'form_send');
    }

  } catch (error) {
    console.error("Ошибка:", error);
    showMessage('Ошибка отправки формы! Пожалуйста, попробуйте позже.', 'error');
  } finally {
    submitButton.disabled = false;
    submitButton.textContent = 'Отправить';
  }
}

/**
 * Инициализация масок и обработчиков
 */
export function initForms() {
  // Обработчики форм
  const forms = document.querySelectorAll('.sendform');
  forms.forEach(form => {
    form.addEventListener("submit", handleFormSubmit);
  });

  // Маска для телефонов
  const phoneInputs = document.querySelectorAll('input[name="phone"]');
  if (phoneInputs.length && typeof IMask !== 'undefined') {
    const maskOptions = {
      mask: '+{7} (#00) 000-00-00',
      placeholderChar: '_',
      lazy: false,
      definitions: { '#': /[49]/ }
    };
    
    phoneInputs.forEach(input => {
      IMask(input, maskOptions);
      input.addEventListener('focus', function() {
        // Дополнительные действия при фокусе
      });
    });
  }
}